// Landing page entry point for index.html
// CSS is now loaded via <link> tag in HTML

console.log('🎮 Multipass Landing Page Loaded')

// Browser compatibility check
function checkBrowserCompatibility() {
  const issues = []
  
  if (!window.WebSocket) {
    issues.push('WebSocket support required')
  }
  
  if (!window.RTCPeerConnection) {
    issues.push('WebRTC support required') 
  }
  
  if (!window.navigator.mediaDevices) {
    issues.push('Media devices access required')
  }
  
  return {
    isSupported: issues.length === 0,
    issues
  }
}

// Initialize landing page functionality
function initLandingPage() {
  const compatibility = checkBrowserCompatibility()
  
  if (!compatibility.isSupported) {
    const statusElement = document.getElementById('loadingStatus')
    if (statusElement) {
      statusElement.innerHTML = `
        <div class="alert alert-warning mt-3">
          <strong>Compatibility Issues:</strong><br>
          ${compatibility.issues.join('<br>')}
        </div>
      `
    }
  }
}

// Progressive Web App features
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
        console.log('SW registered: ', registration)
      })
      .catch((registrationError) => {
        console.log('SW registration failed: ', registrationError)
      })
  })
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initLandingPage)
} else {
  initLandingPage()
}